import React from "react";
import { useEffect, useState } from "react";
import {
  Box,
  Image,
  Text,
  VStack,
  Stack,
  HStack,
  Link,
} from "@chakra-ui/react";
import homebg from "../../../assets/home/bgwithcamel.jpg"; // includes camels now
import divider from "../../../assets/home/divider.png";
import vector from "../../../assets/home/Vector.png";
import person1 from "../../../assets/home/person1.png";
import person2 from "../../../assets/home/person2.png";
import person3 from "../../../assets/home/person3.png";
import FlowerImage from "component/FlowerImage";
import cream from "../../../assets/flower/cream.png";
import red from "../../../assets/flower/redd.png";
import DoggleFlower from "./DoggleFlower";
import lpointer from "../../../assets/home/lpointer.png";

const cardNames = [
  "SEO",
  "Content Writing",
  "Branding",
  "App & Web Development",
  "Email Marketing",
  "Social Media Marketing",
];

const Hero = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % cardNames.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      position="relative"
      overflow="visible"
      w="100%"
      minH={{ base: "30vh", md: "100vh" }}
    >
      <FlowerImage
        src={red}
        top={{ base: "200px", md: 80 }}
        right={{ base: "60px", md: 40 }}
        width={{ base: "30px", md: "auto" }}
      />
      <FlowerImage
        src={cream}
        top={{ base: "200px", md: 40 }}
        left={{ base: 20, md: 60 }}
        width={{ base: "30px", md: "auto" }}
      />

      <Image
        src={homebg}
        alt="Background"
        objectFit="cover"
        position="absolute"
        top="0"
        left="0"
        w="100%"
        h={{ base: "100%", md: "100%" }}
        zIndex={-3}
      />

      <Image
        src={divider}
        alt="Divider"
        objectFit="contain"
        position="absolute"
        bottom={{ base: "-2px", md: 0 }}
        left="0"
        w="100%"
        h={{ base: "auto", md: "auto" }}
        zIndex={4}
      />

      <Link
        href="https://www.google.com/search?q=doggle+india+-+best+in+web+and+app+development+%7C+digital+marketing+%7C+seo+%7C+logo+designing+jaipur+address&oq=doggl&gs_lcrp=EgZjaHJvbWUqBggAEEUYOzIGCAAQRRg7Mg0IARAuGK8BGMcBGIAEMgcIAhAAGIAEMgcIAxAAGIAEMgYIBBBFGDkyBggFEEUYPDIGCAYQRRg8MgYIBxBFGEHSAQgzMTM0ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#lrd=0x396db72c1b6220ef:0x5185845015278001,1,,,,"
        isExternal
        _hover={{ textDecoration: "none" }}
      >
        <HStack
          spacing={2}
          position="absolute"
          top={{ base: "120px", md: 10 }}
          right={{ base: "10px", md: "20px" }}
          zIndex="10"
          bg="transparent"
          p={{ md: 16 }}
          borderRadius="lg"
          cursor={"pointer"}
        >
          <HStack spacing="-10px">
            <Image
              src={person1}
              alt="User 1"
              boxSize="30px"
              borderRadius="full"
              border="2px solid white"
            />
            <Image
              src={person2}
              alt="User 2"
              boxSize="30px"
              borderRadius="full"
              border="2px solid white"
            />
            <Image
              src={person3}
              alt="User 3"
              boxSize="30px"
              borderRadius="full"
              border="2px solid white"
            />
          </HStack>
          <VStack spacing={0} align="start" fontSize="xs" lineHeight="short">
            <Text fontSize="sm" color="white">
              ⭐⭐⭐⭐⭐
            </Text>
            <HStack spacing={1}>
              <Text
                fontWeight="bold"
                fontSize={{ base: "8px" }}
                color="white"
                className="fade-in-up"
              >
                5 / 5
              </Text>
              <Text
                fontSize={{ base: "8px" }}
                color="gray.100"
                className="fade-in-up"
              >
                Based on 20 reviews
              </Text>
            </HStack>
          </VStack>
        </HStack>
      </Link>

      <Stack
        direction="row"
        align="center"
        justify="center"
        px={{ base: 0, md: 0 }}
        pt={{ base: "240px", md: "270px", lg: "270px" }}
        spacing={{ base: 2, md: 0 }}
        zIndex={1}
        flexWrap="wrap"
      >
        <Box position="relative" textAlign="center">
          <Image
            src={vector}
            alt="Temple"
            maxW={{ base: "150px", md: "330px" }}
          />

          <Box
            position="absolute"
            top={{ base: "40%", md: "30%" }}
            left="50%"
            transform="translate(-50%, -50%)"
            px={4}
            w="full"
          >
            <Text
              fontSize={{ base: "xs", md: "3xl" }}
              fontWeight="bold"
              color="white"
              className="fade-in-up"
            >
              You think
              <br />
              we execute
            </Text>
            <Text
              fontSize={{ base: "8px", md: "12px" }}
              color="white"
              mt={{ base: "0", md: 8 }}
              className="fade-in-up"
            >
              Your go-to agency for branding, marketing, and web solutions.
            </Text>
          </Box>

          <Box
            position="absolute"
            top={{base:"110px" , md: "210px" }}
            left="50%"
            transform="translateX(-50%)"
            textAlign="center"
            zIndex={999}
          >
            {/* Pointer Row */}
            <Stack direction="row" spacing={0} justify="center" align="center">
              <Image
                src={lpointer}
                alt="Left pointer"
                maxW={{ base: "50px", md: "100px" }}
                transform="scaleX(-1) rotate(30deg)"
              />

              <Text
                fontSize={{ base: "4px", md: "md" }}
                fontWeight="bold"
                textAlign="center"
                color="white"
                animation="fadeIn 0.5s ease-in-out"
              >
                {cardNames[index]}
              </Text>

              <Image
                src={lpointer}
                alt="Right pointer"
                maxW={{ base: "50px", md: "100px" }}
                transform="rotate(30deg)"
              />
            </Stack>

            <Box mt={{ base: "-80px", md: "-100px" }}>
              <DoggleFlower />
            </Box>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default Hero;
